import { Tag } from "antd";
import type { TagProps } from "antd";

export type UITagProps = TagProps;

export const UITag = (props: UITagProps) => <Tag {...props} />;
